<template>
    <div class="modal" ref="modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Attestato di completamento attività</h5>
                </div>
                <div class="modal-body">
                    <iframe class="bg row h-100 position-relative"
                        :src="iframeSrc"></iframe>
                </div>
                <div class="modal-footer">
                <button type="button" class="btn btn-secondary"
                    @click="onClickNext()">Procedi</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios'

export default{
    components:{
    },
    props:{
        isPatient: {
            type: Boolean,
            default: false
        },
        sessionId: [Number, String],
        userId:  [Number, String]
    },
    data(){
        return{
            modal: null,
            callBack: null,
            iframeSrc: ''
        }
    },
    mounted(){
        this.modal = new window.bootstrap.Modal(this.$refs.modal)
    },
    methods:{
        check(cb){
            this.callBack = cb

            let url = "/structure/student/session/SessionDetailsAction-isAttestatoToNotyfy?userId=" + this.userId + "&sessionId=" + this.sessionId
            if(this.isPatient){
                url = "/patient/HomeAction-isAttestatoToNotyfy?userId=" + this.userId + "&sessionId=" + this.sessionId
            }

            axios.get(url)
                .then(response => {
                    var res = response.data
                    if(res){
                        this.toggle()
                        return
                    }

                    this.close()
                })
        },
        toggle(){
            this.iframeSrc = "/structure/student/session/SessionDetailsAction-printAttestato?userId=" + this.userId + "&sessionId=" + this.sessionId
            if (this.isPatient) {
                this.iframeSrc = "/patient/HomeAction-printAttestato?userId=" + this.userId + "&sessionId=" + this.sessionId
            }

            this.modal.toggle()
        },
        close(){
            if (this.callBack) {
                this.callBack()
            }
        },
        onClickNext(){
            this.modal.hide()
            this.close()
        }
    }
}

</script>
<style scoped>
.modal-body{
    padding: 0;
}

</style>